import React from 'react';
import ReactDOM from 'react-dom/client';

const Car = (props) => {
   console.log("PROPS:",props)
   return <h2>I am a {props.brand}! and my model is {props.model}</h2>;
}

const Garage = () => {
   return (
      <>
         <h1>Who lives in my garage?</h1>
         <Car brand="Ford" model="Endeavour" />
      </>
   );
}

function Football() {
  const shoot = (a) => {
    alert(a);
  }
function Football() {
  return (
    <button onClick={() => shoot("Goal!")}>Take the shot!</button>
  );
}
}

const Learning_23_05_2025 = () => (
   <div>
      <h1>Learning_23_05_2025 Component</h1>
      <p>You Can add it here.
         It is
      </p>
      <Garage />
      <shoot />
   </div>


);

Learning_23_05_2025.propTypes = {};

Learning_23_05_2025.defaultProps = {};

Learning_23_05_2025.eventtypes= {};






export default Learning_23_05_2025;







